import { format } from 'date-fns';
import FormTableCalculateDisplay from '../../../components/form-table-calculate/form-table-calculate.component';
import FormTableHeaderCell from '../../../components/form-table-header-cell/form-table-header-cell.component';
import FormTableInlineDelete from '../../../components/form-table-inline-delete/form-table-inline-delete.component';
import FormTableSelect from '../../../components/form-table-select/form-table-select.component';
import FormTableTextField from '../../../components/form-table-text-field/form-table-text-field.component';
import { useMediaQuery } from 'react-responsive';

export const PURCHASE_ORDER_INFO = {
  formTitle: "Purchase Order",
  formTitleForNew: "New Purchase Order",
  path: "/purchaseorders",
  listPage: "/purchase-orders",
}

export const PURCHASE_ORDER_FORM_TEMPLATE = {
  quickComplete: true,
  approval: true,
  bodySections: {
    basic: {
      sectionType: "basic",
      sectionTypeId: "BASIC",
      expandable: false,
      breakPoint: 2,
      fieldName: "purchaseOrder",
      fieldItems: [
        {
          label: "PO Number",
          type: "text",
          name: "purchaseOrderNumber",
          initialFocus: false,
          disabled: true,
          defaultValue: `PO-`
        },
        {
          label: "Supplier",
          type: "select",
          name: "Supplier",
          required: false,
          initialFocus: false,
          muliselect: false,
          url: "/suppliers",
          // validationProps: {
          //   required: "Supplier is required"
          // }
        },
        // {
        //   label: "Assign To",
        //   type: "select",
        //   name: "User",
        //   required: false,
        //   initialFocus: false,
        //   muliselect: false,
        //   url: "/users"
        // },
        {
          label: "PO Date",
          type: "date",
          name: "purchaseOrderDate",
          initialFocus: false,
          validationProps: {
            required: "PO date is required"
          }
        },
      ]
    },
    tableForm: {
      sectionType: "Products",
      sectionTypeId: "tableForm",
      expandable: true,
      isExpand: true,
      showTotal: true,
      isCurrency: true,
      fieldName: "items",
      isDisable: false,
      tableColumns: [
        {
          Header: () => {
            return (
              <FormTableHeaderCell
                text={"Product Code/Name"}
                required={true}
              />
            )
          },
          accessor: "item",
          width: 305,
          Cell: ({ row }) => {
            const endpointUrl = "/items";
            const validationProps = {
              required: "Product Code/Name is required"
            }

            const isMobileView = useMediaQuery({ maxWidth: 991 });


            return (<FormTableSelect
              fieldName={"items"}
              fieldItemName={"Item"}
              rowNumber={row.id}
              endpointUrl={endpointUrl}
              validationProps={validationProps}
              disabled={row.isDisable}
              headerName={"Product Code/Name"}
              noAvailability={true}
              isMobileView={isMobileView}
              shouldTriggerSelectedField={true}
            />)
          }
        },
        {
          Header: () => {
            return (
              <FormTableHeaderCell
                text={"Quantity"}
                required={true}
              />
            )
          },
          accessor: "qty",
          width: 80,
          Cell: ({ row }) => {
            const validationProps = {
              required: "Qty is required"
            }

            const isMobileView = useMediaQuery({ maxWidth: 991 });

            return (<FormTableTextField
              fieldName={"items"}
              fieldItemName={"qty"}
              rowNumber={row.id}
              valueType={"number"}
              validationProps={validationProps}
              align="right"
              disabled={row.isDisable}
              headerName={"Quantity"}
              isMobileView={isMobileView}
            />)
          }
        },
        {
          Header: () => {
            return (
              <FormTableHeaderCell
                text={"UoM"}
                required={true}
              />
            )
          },
          accessor: "unitOfMeasure",
          width: 85,
          Cell: ({ row }) => {
            const endpointUrl = "/unitofmeasures";
            const validationProps = {
              required: "UoM is required"
            }

            const isMobileView = useMediaQuery({ maxWidth: 991 });

            return (<FormTableSelect
              fieldName={"items"}
              fieldItemName={"UnitOfMeasure"}
              rowNumber={row.id}
              value={row.value}
              endpointUrl={endpointUrl}
              validationProps={validationProps}
              disabled={true}
              headerName={"UoM"}
              isMobileView={isMobileView}
            />)
          }
        },
        {
          Header: () => {
            return (
              <FormTableHeaderCell
                text={"Unit Cost (ETB)"}
                required={true}
              />
            )
          },
          accessor: "unitCost",
          width: 125,
          Cell: ({ row, value }) => {
            const validationProps = {
              required: "Unit cost is required"
            }

            const isMobileView = useMediaQuery({ maxWidth: 991 });

            return (<FormTableTextField
              fieldName={"items"}
              fieldItemName={"unitCost"}
              rowNumber={row.id}
              valueType={"number"}
              validationProps={validationProps}
              align="right"
              disabled={row.isDisable}
              headerName={"Unit Cost (ETB)"}
              isMobileView={isMobileView}
            />)
          }
        },
        {
          Header: "Subtotal (ETB)",
          accessor: "subTotal",
          width: 140,
          Cell: ({ row }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });

            if (isMobileView) {
              return null;
            }

            return (
              <FormTableCalculateDisplay
                fieldName={"items"}
                rowNumber={row.id}
                calculateType="multiply"
                valuesToCalculate={["qty", "unitCost"]}
              />
            )
          }
        },
        {
          id: "action",
          width: 70,
          Cell: ({ row, toggleRowSelected }) => {
            const uuid = row.original.uuid;
            return (<FormTableInlineDelete
              rowNumber={row.id}
              toggleRowSelected={toggleRowSelected}
            />)
          }
        }
      ]
    },
    approvalDetails: {
      sectionType: "Approval",
      sectionTypeId: "approvalDetails",
      multiForm: false,
      expandable: true,
      isExpand: true,
      showEditOnly: true,
      addButton: true,
      breakPoint: 1,
      fieldName: "approvalStatus",
      fieldItems: [
        {
          label: "Current Approval Status",
          type: "select",
          name: "ApprovalStatus",
          initialFocus: false,
          muliselect: false,
          defaultValue: { label: 'Unapproved', value: 2 },
          url: "/approvalstatus"
        }
      ]
    },
    itemTaxDetails: {
      sectionType: "Item tax",
      sectionTypeId: "itemTaxDetails",
      multiForm: false,
      expandable: true,
      isExpand: false,
      addButton: true,
      breakPoint: 1,
      fieldName: "itemTax",
      fieldItems: [
        {
          label: "Item Tax",
          type: "select",
          name: "ItemTax",
          initialFocus: false,
          muliselect: false,
          hasDefaultValue: true,
          defaultValue: { label: 'Excluding Tax', value: 0 }, 
          defaultValueUrl: "/itemtaxesdefault",
          url: "/itemtaxes"
        }
      ]
    },
    shippingDetails: {
      sectionType: "Shipping",
      sectionTypeId: "shippingDetails",
      multiForm: false,
      mutliFormTitle: "Shipping",
      expandable: true,
      isExpand: false,
      addButton: true,
      breakPoint: 1,
      fieldName: "shipping",
      fieldItems: [
        {
          label: "Branch",
          type: "select",
          name: "Location",
          initialFocus: false,
          muliselect: false,
          url: "/locations",
        },
        {
          label: "Shipping Cost (ETB)",
          type: "text",
          name: "shippingCost",
          initialFocus: false,
        },
      ]
    },
    purchaseInvoiceDetails: {
      sectionType: "Invoice",
      sectionTypeId: "invoiceDetails",
      multiForm: false,
      mutliFormTitle: "",
      expandable: true,
      isExpand: false,
      addButton: true,
      breakPoint: 1,
      fieldName: "invoice",
      fieldItems: [
        {
          label: "Supplier Invoice Date",
          type: "date",
          name: "invoicedDate",
          initialFocus: false,
        },
        {
          label: "Supplier Invoice Number",
          type: "text",
          name: "invoiceNumber",
          initialFocus: false,
        },
      ]
    },
    auditHistoryDetails: {
      sectionType: "Audit History",
      sectionTypeId: "auditHistoryDetails",
      multiForm: false,
      expandable: true,
      isExpand: false,
      showEditOnly: true, 
      addButton: true,
      position: "LAST",
      breakPoint: 2,
      fieldName: "auditHistory",
      fieldItems: [
        {
          label: "Created By",
          type: "text",
          name: "createdBy",
          initialFocus: false,
          disabled: true
        },
        {
          label: "Updated By",
          type: "text",
          name: "updatedBy",
          initialFocus: false,
          disabled: true
        },
        {
          label: "Approved By",
          type: "text",
          name: "approvedBy",
          initialFocus: false,
          disabled: true
        },
      ]
    },
  },
  watchFields: [
    "shipping.0.shippingCost",
    "itemTax.0.ItemTax",
    "payment.0.paidAmount",
    "payment.0.availableCreditAmount",
    "payment.0.appliedCreditAmount",
    "payment.0.refundAmount",
    "payment.0.issuedCreditAmount"
  ]
}
